import { render, staticRenderFns } from "./ResumoTable.vue?vue&type=template&id=2cc617cf"
import script from "./ResumoTable.vue?vue&type=script&lang=js"
export * from "./ResumoTable.vue?vue&type=script&lang=js"
import style0 from "./ResumoTable.vue?vue&type=style&index=0&id=2cc617cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports